export const BrandVideoMetadata = {
  id: 'VHMxYZSr8qY',
  title: 'Route: The Service Platform - Brand Video',
  date: new Date('5-17-2019'),
  description:
    'Promotional Video about the Route Brand, our Platform, and our Vision for the future of Building Services.',
  duration: 54,
  src: 'https://www.youtube.com/embed/VHMxYZSr8qY',
  thumbnail: 'https://img.youtube.com/vi/VHMxYZSr8qY/0.jpg',
  url: 'https://www.youtube.com/watch?v=VHMxYZSr8qY',
  views: 125
}

export const ProductVideoMetadata = {
  id: 'CtDaXt0mF94',
  title: 'Route: How It Works',
  date: new Date('3-28-2019'),
  description:
    'Replace your clipboard with Route! Route is the new tech platform for the cleaning service industry. Manage your operations, schedule jobs, conduct walkthroughs, quote estimates and create task lists. All from your phone with pictures and text. FREE 30 Day Trial: https://getroute.com. Book a demo: demo@getroute.com',
  duration: 130,
  src: 'https://www.youtube.com/embed/CtDaXt0mF94',
  thumbnail: 'https://img.youtube.com/vi/CtDaXt0mF94/0.jpg',
  url: 'https://www.youtube.com/watch?v=CtDaXt0mF94',
  views: 144
}

export const RouteNationVideoMetadata = {
  id: 'VHMxYZSr8qY',
  title: 'Welcome To Route Nation',
  date: new Date('6-26-2019'),
  description:
    'Welcome to Route Nation! Route is a web and mobile app designed for the facility service industry. It will guide you through the full life cycle of a job, from the walkthrough to bidding to proposals to operations. Learn more, book a full demo at https://getroute.com',
  duration: 38,
  src: 'https://www.youtube.com/embed/7rlc7B5_uOs',
  thumbnail: 'https://img.youtube.com/vi/7rlc7B5_uOs/0.jpg',
  url: 'https://www.youtube.com/watch?v=7rlc7B5_uOs',
  views: 302
}

export const WalkthroughBuilderVideoMetadata = {
  id: 'aISj68QCyWs',
  title: 'Conduct A Better Walkthrough With Route',
  date: new Date('7-2-2019'),
  description:
    'Welcome to Route Nation! Today Armando explains how to conduct a better walkthrough using Route. Record square footage, fixtures, make specific tasks, take pictures and notes. Ditch the clipboard and conduct walkthroughs all from your phone. Route is a web and mobile app designed for the facility service industry. It will guide you through the full life cycle of a job, from the walkthrough to bidding to proposals to operations. Book a full demo at https://getroute.com',
  duration: 449,
  src: 'https://www.youtube.com/embed/aISj68QCyWs',
  thumbnail: 'https://img.youtube.com/vi/aISj68QCyWs/0.jpg',
  url: 'https://www.youtube.com/watch?v=aISj68QCyWs',
  views: 42
}

export const EstimatorVideoMetadata = {
  id: 'EvfOC_qloMM',
  title: 'Create An Estimate For Any Commercial Cleaning Contract',
  date: new Date('10-4-2019'),
  description:
    'Welcome to Route Nation! Today we are excited to announce our breakthrough estimator tool! Put together an estimate for any commercial cleaning job within minutes. Route is a web and mobile app designed for the facility service industry. It will guide you through the full life cycle of a job, from the walkthrough to bidding to proposals to operations. Learn more, book a full demo at https://getroute.com',
  duration: 305,
  src: 'https://www.youtube.com/embed/EvfOC_qloMM',
  thumbnail: 'https://img.youtube.com/vi/EvfOC_qloMM/0.jpg',
  url: 'https://www.youtube.com/watch?v=EvfOC_qloMM',
  views: 131
}

export const ProposalGeneratorVideoMetadata = {
  id: 'Tp_lX6I5H5k',
  title: 'Send A Quick, Professional Proposal With Route',
  date: new Date('7-11-2019'),
  description:
    'Welcome to Route Nation! Today Armando explains how to turn a walkthrough into a proposal using Route. Add charges, sell on other services, generate legal all with one app. Speed up your sales conversion by creating thorough proposals in minutes. Route is a web and mobile app designed for the facility service industry. It will guide you through the full life cycle of a job, from the walkthrough to bidding to proposals to operations. Book a full demo at https://getroute.com',
  duration: 336,
  src: 'https://www.youtube.com/embed/Tp_lX6I5H5k',
  thumbnail: 'https://img.youtube.com/vi/Tp_lX6I5H5k/0.jpg',
  url: 'https://www.youtube.com/watch?v=Tp_lX6I5H5k',
  views: 138
}

export const InspectionReportsVideoMetadata = {
  id: 'GBNDpUkZXII',
  title: 'Effortlessly Conduct An Inspection With Route',
  date: new Date('7-22-2019'),
  description:
    'Welcome to Route Nation! Today Armando explains how to turn a walkthrough into an inspection using Route. Make a list of acceptable areas and areas that need improvement. Then quickly send the results to the technician. Route is a web and mobile app designed for the facility service industry. It will guide you through the full life cycle of a job, from the walkthrough to bidding to proposals to operations. Book a full demo at https://getroute.com',
  duration: 284,
  src: 'https://www.youtube.com/embed/GBNDpUkZXII',
  thumbnail: 'https://img.youtube.com/vi/GBNDpUkZXII/0.jpg',
  url: 'https://www.youtube.com/watch?v=GBNDpUkZXII',
  views: 5
}

export const ContractorInnovationVideoMetadata = {
  id: 'ZWl6ABX9MGs',
  title: 'Ricky On Contractor Innovation',
  date: new Date('7-10-2019'),
  description: "Route's Founder Ricardo Regalado joins Contractor Innovation live.",
  duration: 31,
  src: 'https://www.youtube.com/embed/ZWl6ABX9MGs',
  thumbnail: 'https://img.youtube.com/vi/ZWl6ABX9MGs/0.jpg',
  url: 'https://www.youtube.com/watch?v=ZWl6ABX9MGs',
  views: 12
}

export const RickyTalksRouteVideoMetadata = {
  id: 'nnE0B9hGdA0',
  title: 'Ricardo Regalado Talks About Route',
  date: new Date('1-14-2019'),
  description:
    'Ricardo Regalado, founder and CEO of Route, discusses the Route platform and the initial motivation for the creation of software to change the Building Services Industry.',
  duration: 38,
  src: 'https://www.youtube.com/embed/nnE0B9hGdA0',
  thumbnail: 'https://img.youtube.com/vi/nnE0B9hGdA0/0.jpg',
  url: 'https://www.youtube.com/watch?v=nnE0B9hGdA0',
  views: 32
}

export const WalkthroughBuilderOldVideoMetadata = {
  id: 'kmoSmYWp9nE',
  title: 'Route Walkthrough Builder&#8482;',
  date: new Date('1-14-2019'),
  description:
    "This video provides a brief overview of Route's Walkthrough Builder&#8482; tool. Create, schedule, and perform a Walkthrough of your client's location in just a few minutes!",
  duration: 94,
  src: 'https://www.youtube.com/embed/kmoSmYWp9nE',
  thumbnail: 'https://img.youtube.com/vi/kmoSmYWp9nE/0.jpg',
  url: 'https://www.youtube.com/watch?v=kmoSmYWp9nE',
  views: 92
}

export const Sales123VideoMetadata = {
  id: 'jAbOmuu0Rw4',
  title: 'How Route Works - Simple as 1-2-3!',
  date: new Date('11-25-2019'),
  description:
    'What is Route? How does it work? Route is a sales platform for the services industry and allows you to close more deals faster than ever before. It digitizes your sales process and helps your company grow!',
  duration: 119,
  src: 'https://www.youtube.com/embed/jAbOmuu0Rw4',
  thumbnail: 'https://img.youtube.com/vi/jAbOmuu0Rw4/0.jpg',
  url: 'https://www.youtube.com/watch?v=jAbOmuu0Rw4',
  views: 248
}

export const TheNextStepVideoMetadata = {
  id: 'lC46C7w-0nU',
  title: 'The Next Step',
  date: new Date('1-31-2020'),
  description:
    "Take the next step for your Commercial Cleaning company TODAY! Work collaboratively with your team to close more deals in record time. Route's sales features were made FROM the industry FOR the industry.",
  duration: 68,
  src: 'https://youtu.be/lC46C7w-0nU',
  thumbnail: 'https://youtu.be/lC46C7w-0nU/0.jpg',
  url: 'https://www.youtube.com/watch?v=lC46C7w-0nU',
  views: 58
}

export const FromQuickBidToProposalVideoMetadata = {
  id: 'bkCZ6S0EJys',
  title: 'From QuickBid To Proposal',
  date: new Date('7-7-2020'),
  description:
    'Learn how Route helps you efficiently generate a detailed, stunning proposal for your prospect with the help of custom templates and proposal elements.',
  duration: 25,
  src: 'https://www.youtube.com/embed/bkCZ6S0EJys',
  thumbnail: 'https://youtu.be/bkCZ6S0EJys/0.jpg',
  url: 'https://www.youtube.com/watch?v=bkCZ6S0EJys',
  views: 0
}

export const RouteDemoVideoMetadata = {
  id: 'cyeKcyeFk58',
  title: 'Route Demo Video',
  date: new Date('7-28-2022'),
  description:
    "Get a quick overview of Route's functionality.",
  duration: 184,
  src: 'https://www.youtube.com/embed/cyeKcyeFk58',
  thumbnail: 'https://youtu.be/cyeKcyeFk58/0.jpg',
  url: 'https://www.youtube.com/watch?v=cyeKcyeFk58',
  views: 2
}

export const RouteMarketplaceVideoMetadata = {
  id: 'cdbc2FMDaw4',
  title: 'Route Marketplace',
  date: new Date('10-10-2022'),
  description:
    "Route Marketplace.",
  duration: 40,
  src: 'https://www.youtube.com/embed/cdbc2FMDaw4',
  thumbnail: 'https://youtu.be/cdbc2FMDaw4/0.jpg',
  url: 'https://www.youtube.com/watch?v=cdbc2FMDaw4',
  views: 1
}

export const RoutePlusVideoMetadata = {
  id: 'VoihlkD_RsU',
  title: 'Route+',
  date: new Date('10-10-2022'),
  description:
    "Learn how Route helps you efficiently generate a detailed, stunning proposal for your prospect with the help of custom templates and proposal elements.",
  duration: 111,
  src: 'https://www.youtube.com/embed/VoihlkD_RsU',
  thumbnail: 'https://youtu.be/VoihlkD_RsU/0.jpg',
  url: 'https://www.youtube.com/watch?v=VoihlkD_RsU',
  views: 1
}

export default {
  VHMxYZSr8qY: {
    id: 'VHMxYZSr8qY',
    title: 'Route: The Service Platform - Brand Video',
    date: new Date('5-17-2019'),
    description:
      'Promotional Video about the Route Brand, our Platform, and our Vision for the future of Building Services.',
    duration: 54,
    src: 'https://www.youtube.com/embed/VHMxYZSr8qY',
    thumbnail: 'https://img.youtube.com/vi/VHMxYZSr8qY/0.jpg',
    url: 'https://www.youtube.com/watch?v=VHMxYZSr8qY',
    views: 125
  },
  CtDaXt0mF94: {
    id: 'CtDaXt0mF94',
    title: 'Route: How It Works',
    date: new Date('3-28-2019'),
    description:
      'Replace your clipboard with Route! Route is the new tech platform for the cleaning service industry. Manage your operations, schedule jobs, conduct walkthroughs, quote estimates and create task lists. All from your phone with pictures and text. FREE 30 Day Trial: https://getroute.com. Book a demo: demo@getroute.com',
    duration: 130,
    src: 'https://www.youtube.com/embed/CtDaXt0mF94',
    thumbnail: 'https://img.youtube.com/vi/CtDaXt0mF94/0.jpg',
    url: 'https://www.youtube.com/watch?v=CtDaXt0mF94',
    views: 144
  },
  '7rlc7B5_uOs': {
    id: '7rlc7B5_uOs',
    title: 'Welcome To Route Nation',
    date: new Date('6-26-2019'),
    description:
      'Welcome to Route Nation! Route is a web and mobile app designed for the facility service industry. It will guide you through the full life cycle of a job, from the walkthrough to bidding to proposals to operations. Learn more, book a full demo at https://getroute.com',
    duration: 38,
    src: 'https://www.youtube.com/embed/7rlc7B5_uOs',
    thumbnail: 'https://img.youtube.com/vi/7rlc7B5_uOs/0.jpg',
    url: 'https://www.youtube.com/watch?v=7rlc7B5_uOs',
    views: 302
  },
  aISj68QCyWs: {
    id: 'aISj68QCyWs',
    title: 'Conduct A Better Walkthrough With Route',
    date: new Date('7-2-2019'),
    description:
      'Welcome to Route Nation! Today Armando explains how to conduct a better walkthrough using Route. Record square footage, fixtures, make specific tasks, take pictures and notes. Ditch the clipboard and conduct walkthroughs all from your phone. Route is a web and mobile app designed for the facility service industry. It will guide you through the full life cycle of a job, from the walkthrough to bidding to proposals to operations. Book a full demo at https://getroute.com',
    duration: 449,
    src: 'https://www.youtube.com/embed/aISj68QCyWs',
    thumbnail: 'https://img.youtube.com/vi/aISj68QCyWs/0.jpg',
    url: 'https://www.youtube.com/watch?v=aISj68QCyWs',
    views: 42
  },
  Tp_lX6I5H5k: {
    id: 'Tp_lX6I5H5k',
    title: 'Send A Quick, Professional Proposal With Route',
    date: new Date('7-11-2019'),
    description:
      'Welcome to Route Nation! Today Armando explains how to turn a walkthrough into a proposal using Route. Add charges, sell on other services, generate legal all with one app. Speed up your sales conversion by creating thorough proposals in minutes. Route is a web and mobile app designed for the facility service industry. It will guide you through the full life cycle of a job, from the walkthrough to bidding to proposals to operations. Book a full demo at https://getroute.com',
    duration: 336,
    src: 'https://www.youtube.com/embed/Tp_lX6I5H5k',
    thumbnail: 'https://img.youtube.com/vi/Tp_lX6I5H5k/0.jpg',
    url: 'https://www.youtube.com/watch?v=Tp_lX6I5H5k',
    views: 22
  },
  GBNDpUkZXII: {
    id: 'GBNDpUkZXII',
    title: 'Effortlessly Conduct An Inspection With Route',
    date: new Date('7-22-2019'),
    description:
      'Welcome to Route Nation! Today Armando explains how to turn a walkthrough into an inspection using Route. Make a list of acceptable areas and areas that need improvement. Then quickly send the results to the technician. Route is a web and mobile app designed for the facility service industry. It will guide you through the full life cycle of a job, from the walkthrough to bidding to proposals to operations. Book a full demo at https://getroute.com',
    duration: 284,
    src: 'https://www.youtube.com/embed/GBNDpUkZXII',
    thumbnail: 'https://img.youtube.com/vi/GBNDpUkZXII/0.jpg',
    url: 'https://www.youtube.com/watch?v=GBNDpUkZXII',
    views: 5
  },
  ZWl6ABX9MGs: {
    id: 'ZWl6ABX9MGs',
    title: 'Ricky On Contractor Innovation',
    date: new Date('7-10-2019'),
    description: "Route's Founder Ricardo Regalado joins Contractor Innovation live.",
    duration: 31,
    src: 'https://www.youtube.com/embed/ZWl6ABX9MGs',
    thumbnail: 'https://img.youtube.com/vi/ZWl6ABX9MGs/0.jpg',
    url: 'https://www.youtube.com/watch?v=ZWl6ABX9MGs',
    views: 12
  },
  nnE0B9hGdA0: {
    id: 'nnE0B9hGdA0',
    title: 'Ricardo Regalado Talks About Route',
    date: new Date('1-14-2019'),
    description:
      'Ricardo Regalado, founder and CEO of Route, discusses the Route platform and the initial motivation for the creation of software to change the Building Services Industry.',
    duration: 38,
    src: 'https://www.youtube.com/embed/nnE0B9hGdA0',
    thumbnail: 'https://img.youtube.com/vi/nnE0B9hGdA0/0.jpg',
    url: 'https://www.youtube.com/watch?v=nnE0B9hGdA0',
    views: 32
  },
  kmoSmYWp9nE: {
    id: 'kmoSmYWp9nE',
    title: 'Route Walkthrough Builder&#8482;',
    date: new Date('1-14-2019'),
    description:
      "This video provides a brief overview of Route's Walkthrough Builder&#8482; tool. Create, schedule, and perform a Walkthrough of your client's location in just a few minutes!",
    duration: 94,
    src: 'https://www.youtube.com/embed/kmoSmYWp9nE',
    thumbnail: 'https://img.youtube.com/vi/kmoSmYWp9nE/0.jpg',
    url: 'https://www.youtube.com/watch?v=kmoSmYWp9nE',
    views: 92
  },
  'lC46C7w-0nU': {
    id: 'lC46C7w-0nU',
    title: 'The Next Step',
    date: new Date('1-31-2020'),
    description:
      "Take the next step for your Commercial Cleaning company TODAY! Work collaboratively with your team to close more deals in record time. Route's sales features were made FROM the industry FOR the industry.",
    duration: 68,
    src: 'https://youtu.be/lC46C7w-0nU',
    thumbnail: 'https://youtu.be/lC46C7w-0nU/0.jpg',
    url: 'https://www.youtube.com/watch?v=lC46C7w-0nU',
    views: 58
  },
  bkCZ6S0EJys: {
    id: 'bkCZ6S0EJys',
    title: 'From QuickBid To Proposal',
    date: new Date('7-7-2020'),
    description:
      'Learn how Route helps you efficiently generate a detailed, stunning proposal for your prospect with the help of custom templates and proposal elements.',
    duration: 25,
    src: 'https://youtu.be/bkCZ6S0EJys',
    thumbnail: 'https://youtu.be/bkCZ6S0EJys/0.jpg',
    url: 'https://www.youtube.com/watch?v=bkCZ6S0EJys',
    views: 0
  },
  cyeKcyeFk58 : {
    id: 'cyeKcyeFk58',
    title: 'Route Demo Video',
    date: new Date('7-28-2022'),
    description:
      "Get a quick overview of Route's functionality.",
    duration: 184,
    src: 'https://www.youtube.com/embed/cyeKcyeFk58',
    thumbnail: 'https://youtu.be/cyeKcyeFk58/0.jpg',
    url: 'https://www.youtube.com/watch?v=cyeKcyeFk58',
    views: 2
  },
  cdbc2FMDaw4: {
    id: 'cdbc2FMDaw4',
    title: 'Route Marketplace',
    date: new Date('10-10-2022'),
    description:
      "Route Marketplace.",
    duration: 40,
    src: 'https://www.youtube.com/embed/cdbc2FMDaw4',
    thumbnail: 'https://youtu.be/cdbc2FMDaw4/0.jpg',
    url: 'https://www.youtube.com/watch?v=cdbc2FMDaw4',
    views: 1
  },
  VoihlkD_RsU: {
    id: 'VoihlkD_RsU',
    title: 'Route+',
    date: new Date('10-10-2022'),
    description:
      "Learn how Route helps you efficiently generate a detailed, stunning proposal for your prospect with the help of custom templates and proposal elements.",
    duration: 111,
    src: 'https://www.youtube.com/embed/VoihlkD_RsU',
    thumbnail: 'https://youtu.be/VoihlkD_RsU/0.jpg',
    url: 'https://www.youtube.com/watch?v=VoihlkD_RsU',
    views: 1
  }
}
